export const ROUTE_NAMES = {
  home: '/home',
  privacyPolicy: '/privacy-policy',
  cookiesPolicy: '/cookies-policy',
  contactUs: '/contact-us',
  testDrive: '/test-drive',
  EPCROfficialAutomotivePartner: '/EPCR-official-automotive-partner',
  findADealer: '/find-a-dealer',
};
